/**
 * Cada paso de un asistente empieza arriba.
 *
 * Se llega a un paso con «Siguiente», que está al pie, y el paso nuevo se abría
 * por donde acababa el anterior: en el teléfono había que subir para leer el
 * título y bajar otra vez para seguir. Quién se desplaza cambia según el ancho
 * —en escritorio el formulario, en el teléfono el cuerpo entero o la página—,
 * así que no se apunta a uno: se sube todo lo que esté desplazado dentro del
 * asistente, y la página si es ella la que se movió.
 */
import { useEffect, useRef, type RefObject } from 'react'

export function useScrollTopOnStep(step: unknown, rootRef?: RefObject<HTMLElement | null>): void {
  const first = useRef(true)
  useEffect(() => {
    // Al abrir no: el asistente ya empieza arriba y no hay nada que mover.
    if (first.current) { first.current = false; return }
    const root = rootRef?.current
    if (root) {
      if (root.scrollTop > 0) root.scrollTop = 0
      root.querySelectorAll<HTMLElement>('*').forEach((element) => {
        if (element.scrollTop > 0) element.scrollTop = 0
      })
    }
    if (window.scrollY > 0) window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [step, rootRef])
}
